/** 隊伍識別色。0 藍方、1 紅方；中立單位另行指定。 */
export const TEAM_COLORS = [0x65d9d1, 0xf18c87] as const;

/** 中立單位的暖色，用來和兩隊的冷／暖色區隔。 */
export const NEUTRAL_COLOR = 0xfac57c;
